export default __webpack_public_path__ + "static/media/SlamClubLogo.6982f7ed.jpeg";